<template>
    <ac-modal :title="'Verify Group Offering Update'" ref="modal" @ac-modal-closed="cancel">
        <template>
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-warning">
                        <p>
                            The following employees are associated with the plan you are about to remove:
                        </p>
                        <p v-for="ac in affectedConsumers">
                            {{ac.firstName}}&nbsp;{{ac.lastName}} - Plan effective date: {{ac.planEffectiveDate | shortDate}}
                        </p>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="terminate-plans" v-model="terminatePlans" />
                        <label class="form-check-label" for="terminate-plans">&nbsp;Terminate Patient Plans</label>
                    </div>
                </div>
            </div>
        </template>
        <template slot="buttons">
            <ac-button type="button" class="btn btn-sm btn-green" :action="update">
                UPDATE
            </ac-button>
            <ac-button type="button" class="btn btn-sm btn-red" :action="cancel">
                CANCEL
            </ac-button>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    const UPDATE_OFFERING = "update";

    export default {
        name: "PlanRemovalVerificationModal",
        props: {consultantId: {type: [Number], required: true}},
        data() {
            return {
                affectedConsumers: [],
                resolve: null,
                terminatePlans: false,
            }
        },
        methods: {
            async showModal({planPoolId, planId}) {
                let prom = new Promise((resolve, reject) => { this.resolve = resolve; });
                this.affectedConsumers = [];
                this.affectedConsumers = await this.getAffectedMembers(planPoolId, planId);

                if (Array.isArray(this.affectedConsumers) && this.affectedConsumers.length > 0) 
                {
                    this.$refs.modal.open();
                } 
                else {
                    this.resolve(UPDATE_OFFERING);
                }
                return prom;
            },
            getAffectedMembers(planPoolId, planId) {
                return api.getDataWithTwoIds(
                    'MediatorPlan', this.consultantId, `GetConsumersInPlanAndPool/${planPoolId}`, planId);
            },
            update() {
                this.resolve(this.terminatePlans ? "terminate" : UPDATE_OFFERING);
                this.close();
            },
            cancel() {
                this.resolve(false);
                this.close();
            },
            close() {
                this.$refs.modal.close();
            },
        }
    }
</script>

<style scoped>

</style>